var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"goods-item-con u-flex-col u-text-center"},'div',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.$attrs.goodsImg}}),_c('p',[_vm._v(_vm._s(_vm.$attrs.goodsTitle))]),_c('span',[_vm._v(_vm._s(_vm.$attrs.goodsPrice))])])
}
var staticRenderFns = []

export { render, staticRenderFns }